<template>
  <div class="card">
    <!-- Card Header -->
    <div class="header-row border-b border-gray-200">å
      <span class="text-capitalize">{{view}}</span> Send To Details
      <a target="_blank" :href="`/view/send-to-types#${sendToDetails.send_to_type}`" class="std-help-link">
        <i class="fa fa-question"></i>
      </a>
    </div>

    <!-- Card Body -->
    <div class="card-body lead-form">

      <!-- General Info Section-->
      <section class="general-info">
        <!-- Recruting ID and Send To Type -->
        <div class="line-slipt">


          <div class="form-group send-to-type-field">
            <label for="send_to_type">Send to Type</label>
            <select class="form-control" v-model="sendToDetails.send_to_type">
              <option v-for="type in sendToTypes" v-bind:value="type">{{ type }}</option>
            </select>
            <span v-if="loading">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
          </div>
        </div>

        <!-- Credential Label -->
        <div class="form-group form-group-half">
          <span v-html="label('optional_credential_label', 'Credential Label')"></span>
          <input
            type="text"
            data-form-type="other"
            class="form-control"
            :value="sendToDetails.optional_credential_label"
            @input="update('optional_credential_label', $event.target.value)"
            id="optional_credential_label"
            name="optional_credential_label" />
        </div>

        <!-- Email addresses -->
        <div class="form-group form-group-half">
          <span v-html="label('email_addresses', 'Email Addresses')"></span>
          <input
            type="text"
            class="form-control"
            data-form-type="other"
            :value="sendToDetails.email_addresses"
            @input="update('email_addresses', $event.target.value)"
            id="email_addresses"
            name="email_addresses"
            placeholder="joe@dirt.com, jon@doe.com" />
          <small id="emailHelp" class="form-text text-muted">Comma separate email address</small>
        </div>

        <!-- Referral Code -->
        <div class="form-group form-group-half">
          <span v-html="label('referral_code', 'Referral Code')"></span>
          <input
            type="text"
            class="form-control"
            data-form-type="other"
            :value="sendToDetails.referral_code"
            @input="update('referral_code', $event.target.value)"
            id="referral_code"
            name="referral_code" />
        </div>

        <!-- Keyword -->
        <div class="form-group form-group-half">
          <span v-html="label('keyword', 'Keyword')"></span>
          <input
            type="text"
            class="form-control"
            data-form-type="other"
            :value="sendToDetails.keyword"
            @input="update('keyword', $event.target.value)"
            id="keyword"
            name="keyword"  />
        </div>
      </section>
      <hr style="margin: 2rem 0" />

      <!-- JSON Info Section -->
      <section class="json-info">
        <h5>
          <span v-html="label('json_info', 'JSON Info')"></span>
        </h5>
        <nav-tabs :nav-items="['Basic', 'Builder', 'Raw']">
          <!-- Basic Tab -->
          <template v-slot:basic>
            <div class="line-slipt">
              <div class="form-group" style="margin-bottom: 0.25rem">
                <label for="">Key</label>
                <input data-form-type="other" type="text" v-model="key" class="form-control" placeholder="key">
              </div>

              <div class="form-group" style="margin-bottom: 0.25rem; flex-grow: 2;">
                <label for="">Value</label>
                <input data-form-type="other" type="text" v-model="value" class="form-control" placeholder="value" />
              </div>
              <div style="display: flex; align-items: flex-end; margin-bottom: 0.25rem;">
                <button style="margin-right: 0.5rem;" class="btn btn-dark" @click="updateJsonByKeyValue">Add/Update</button>
                <button class="btn btn-danger" @click="removeJsonByKeyValue">Remove</button>
              </div>
            </div>

            <small style="display: block">To remove an item, input the key you wish to remove then click the remove button.</small>
            <small style="display: block">Adding a key that already exists will overwrite the current key/value.</small>

            <div class="relative flex flex-col border border-gray-200mt-3 mb-0">
              <div class="header-row border-b border-gray-200">Data</div>
              <div class="card-body">
                <json-viewer :json="JSON.stringify(jsonInfo)" />
              </div>
            </div>
          </template>

          <!-- Builder Tab -->
          <template v-slot:builder>
            <JsonEditor :objData="jsonInfo || {}" v-model="jsonInfo" ></JsonEditor>
          </template>

          <!-- Raw Tab -->
          <template v-slot:raw>
            <div class="card">
              <div class="header-row border-b border-gray-200">Data</div>
              <div class="card-body">
                <textarea rows="6" class="form-control" @blur="jsonInfo = $event.target.value" :value="JSON.stringify(jsonInfo)"></textarea>
              </div>
            </div>
          </template>
        </nav-tabs>
      </section>
      <hr style="margin: 2rem 0" />

      <!-- Credentials Section -->
      <section class="credentials">
        <h5>Credentials</h5>
        <nav-tabs :nav-items="['API', 'FTP']">
          <template v-slot:api>
            <div class="form-group form-group-half">
              <span v-html="label('api_host', 'Hostname')"></span>
              <input
                type="text"
                class="form-control"
                data-form-type="other"
                :value="sendToDetails.api_host"
                @input="update('api_host', $event.target.value)"
                id="api_host"
                name="api_host" />
            </div>

            <div class="form-group form-group-half">
              <span v-html="label('api_key', 'Key')"></span>
              <input
                type="text"
                class="form-control"
                data-form-type="other"
                :value="sendToDetails.api_key"
                @input="update('api_key', $event.target.value)"
                id="api_key"
                name="api_key"  />
            </div>

            <div class="form-group form-group-half">
              <span v-html="label('api_password', 'Password')"></span>
              <password-input
                id="api_password"
                :value="sendToDetails.api_password"
                @input="update('api_password', $event)"
              />
            </div>
          </template>
          <template v-slot:ftp>
            <div class="form-group form-group-half">
              <span v-html="label('ftp_host', 'Hostname')"></span>
              <input
                type="text"
                class="form-control"
                data-form-type="other"
                :value="sendToDetails.ftp_host"
                @input="update('ftp_host', $event.target.value)"
                id="ftp_host"
                name="ftp_host"  />
            </div>

            <div class="form-group form-group-half">
              <span v-html="label('ftp_user', 'Username')"></span>
              <input
                type="text"
                class="form-control"
                data-form-type="other"
                :value="sendToDetails.ftp_user"
                @input="update('ftp_user', $event.target.value)"
                id="ftp_user"
                name="ftp_user"  />
            </div>

            <div class="form-group form-group-half">
              <span v-html="label('ftp_password', 'Password')"></span>
              <password-input
                :value="sendToDetails.ftp_password"
                @input="update('ftp_password', $event)"
                id="ftp_password"
              />
            </div>

            <div class="form-group form-group-half">
              <span v-html="label('ftp_filename', 'File Name')"></span>
              <input
                type="text"
                class="form-control"
                data-form-type="other"
                :value="sendToDetails.ftp_filename"
                @input="update('ftp_filename', $event.target.value)"
                id="ftp_filename"
                name="ftp_filename"  />
            </div>
          </template>
        </nav-tabs>
      </section>

    </div>

    <!-- Card Footer -->
    <div style="text-align: right" class="card-footer">
      <a :href="urls.cancelUrl" class="btn btn-secondary" :disabled="saving">Cancel</a>
      <button
        class="btn btn-primary"
        v-on:click="$store.dispatch('sendToDetails/save')"
        :disabled="loading || !sendToDetails.send_to_type || saving"
      >
        <i v-if="saving" class="fa fa-spinner fa-spin"></i> Save
      </button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default{
    props:{
      view: String
    },
    data(){
      return {
        key: '',
        value: ''
      }
    },
    computed:{
      ...mapState('sendToDetails',[
        'sendToTypes',
        'invalids',
        'loading',
        'leadTableColumns',
        'current',
        'urls',
        'saving',
        'companies'
      ]),
      sendToDetails(){
        return this.$store.state.sendToDetails.current.sendToDetails
      },
      rules(){
        return this.$store.state.sendToDetails.current.rules
      },
      jsonInfo:{
        get(){
          return this.$store.state.sendToDetails.current.jsonData
        },
        set(value){
          if(typeof value === 'string'){
            value = JSON.parse(value)
          }
          Object.keys(value).forEach((key)=>{
            this.$store.commit('sendToDetails/UPDATE_CURRENT_JSON_DATA_FOR_KEY', {
              key: key,
              value: value[key]
            })
          })

        }
      },
      companyQuery:{
        get(){
          return this.$store.state.sendToDetails.companyQuery
        },
        set(value){
          this.$store.commit('sendToDetails/SET_COMPANY_QUERY', value)
        }
      }
    },
    methods:{
      label(column_key, label){
        let vendor_label = '',
          error = this.invalids.root.includes(column_key) ? 'error' : '';
        if( this.rules[column_key] && this.rules[column_key].label  ){
          let setting = this.rules[column_key];
          let required = setting.required ? '<span class="required"></span>' : '';
          let description = setting.description ? `<br>(${setting.description})` : '';
          vendor_label = `<small class="vendor-specific-label">${setting.label} ${description}${required}</small>`;
        }

        return `<label class="${error}" for="${column_key}">${label}${vendor_label}</label>`
      },
      updateJsonByKeyValue() {

        if(this.key == '') {
          return;
        }

        try {
          const value = JSON.parse(this.value);
          this.jsonInfo[this.key] = value
        } catch(e) {
          this.jsonInfo[this.key] = this.value;
        }

        this.key = '';
        this.value = '';
      },
      removeJsonByKeyValue() {
        if(this.jsonInfo.hasOwnProperty(this.key)) {
          this.$store.commit('sendToDetails/REMOVE_PROP_FROM_JSON_DATA', this.key)
          this.key = '';
          this.value = '';
        }
      },
      update(key, value){
        const sendToDetails = this.sendToDetails;
        sendToDetails[key] = value;
        this.$store.commit('sendToDetails/UPDATE_CURRENT_SEND_TO_DETAILS', sendToDetails)
      },
    },
    watch:{
      '$store.state.sendToDetails.current.sendToDetails.company_ID':{
        handler(value){
          setTimeout(()=>{
            this.$refs.companySearch.inputValue = value.toString()
          }, 5)
        }
      }
    },
    mounted(){
      if(this.$store.state.sendToDetails.current.sendToDetails.company_ID){
        this.$refs.companySearch.inputValue = this.$store.state.sendToDetails.current.sendToDetails.company_ID.toString()
      }
    }
  }
</script>
<style lang="scss">
  label.error{
    color: #dc3545;
  }
  label .vendor-specific-label{
    display:block;
    .required{
      color:#dc3545;
      font-size:1.6em;
      &:after{
        content:"*";
      }
    }
  }
  .send-to-type-field{
    position: relative;
    span{
      position:absolute;
      bottom:7px;
      right:-25px;
    }
  }
</style>
